import React, {useEffect, useState} from 'react';
import { Typography, Divider, Box, makeStyles, Grid, Button } from '@material-ui/core';
import SearchCaseForm from '../shared/SearchCaseForm';
import SuccessResult from '../shared/SuccessResult';
import { getSearchFormDetailsMainCase, generateTemplate, getSearchFormDetailsInCaseListing, fetchBenchNumber, getSearchFormDetailsMainCaseByDiaryNumber } from 'features/Tdsat/API/TdsatApi';
import { format } from 'date-fns';
import { useSnackbar } from 'contexts/SnackbarContext';
import Swal from 'sweetalert2';
import instance from 'api/globalaxios';
import AddingDetailsTabs from './AddingDetailsTabs';

const useStyles = makeStyles((theme)=>({
  form: {
    maxWidth: 600,
    margin: '0 auto',
    padding: theme.spacing(3),
  },
  title: {
    marginBottom: theme.spacing(10),
    marginTop: theme.spacing(2.5),
  },
  paper: {
    padding: theme.spacing(4),
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 600,
    marginBottom: theme.spacing(4),
    borderRadius: '10px',
    marginTop:  theme.spacing(4),
  },
  titleHeader: {
    fontSize: '22px',
    color: '#4A3BFF',
    fontWeight: 700
  },
  formItem: {
    width: '100%',
  },
  rowItem: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  advocateInfo: {
    fontWeight: 500,
    marginBottom: '1.5rem',
  },
  advocateInfoTitle: {
    fontSize: '18px',
    fontWeight: 400,
    fontFamily: 'Satoshi'
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    borderRadius: '12px',
    padding: theme.spacing(1),
  },
  formItem: {
    marginBottom: '1rem',
    width: '100%',
  },
  uploadButton: {
    marginBottom: '1rem',
    display: 'flex',
    justifyContent: 'center',
  },
  label: {
    color: '#121212',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.3125rem',
    textAlign: 'left',
    marginBottom: '0.2rem',
  },
  submitButton: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
    marginBottom: '20px',
  },
  noBorders: {
    border: 'none',
    fontSize: '15px',
    
  },
  noBordersUploaded: {
    border: 'none',
    fontSize: '15px',
    // background: '#E8FFE2'
  },
  noBordersTitle: {
    border: 'none',
    fontSize: '15px',
    fontFamily: 'Satoshi-Bold',
  },
  table: {
    minWidth: 650,
    width: '100%',
    maxWidth: '100%'
  },
  tableRow: {
    '& tr': {
      marginBottom: '8px !important'  
    },
    '& th, & td': { 
      padding: '26px !important',  
    },
    border: '1px solid #E5E5E5',
    background: '#fff',
  },
  tabContainer: {
    marginBottom: theme.spacing(2),
  },
  accordionTitle: {
		fontSize: '16px',
		fontFamily: "Satoshi-Medium",
    fontWeight: 700,
    marginBottom: '15px',
    marginTop: '25px'
	},
  caseHeading: {
    fontSize: '20px',
    fontWeight: 500,
    marginBottom: '20px'
  }
}));

const AdditionalPartyDetails = () => {
  const classes= useStyles();
  const [formData, setFormData] = useState({
    selectType: 'caseNumber',
  });
  const { showSnackbar } = useSnackbar();
  
  const [searchResponse, setSearchResponse] = useState();

  const handleSearch = async (searchParams) => {
    try {
      const caseNumber = searchParams?.case_number;
      const diaryNumber = searchParams?.diary_number;
      const year = searchParams.year;
      const caseType = searchParams.case_type;
      let response;

      if (caseNumber) {
        response = await getSearchFormDetailsMainCase(caseNumber, year, caseType, "additional_details");
      } else if (diaryNumber) {
        response = await getSearchFormDetailsMainCaseByDiaryNumber(diaryNumber, year, caseType, "additional_details");
      } else {
        throw new Error("Either caseNumber or diaryNumber must be provided.");
      }
      if(response?.data?.main_case){
        showSnackbar('Searched Successfully', 'success');
      } else if(response?.data?.error){
        showSnackbar(response?.data?.error, 'error');
      }
      setSearchResponse(response?.data)
    } catch (error) {
      if(error?.response?.status === 400){
        showSnackbar(error?.response?.data?.error, 'error');
      }
      console.error("Error searching case:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }; 


  return (
    <Box style={{display: 'flex', alignItems: 'center', flexDirection: 'column', width: '100%'}}>
       <Grid container alignItems="center" style={{justifyContent: 'center'}}>
          <Grid item>
            <Typography className={classes.titleTop}>ADDITIONAL DETAILS</Typography>
          </Grid>
        </Grid>
        <SearchCaseForm classes={classes} formData={formData} handleInputChange={handleInputChange} handleSearch={handleSearch} />

        {searchResponse?.main_case && (
          <AddingDetailsTabs searchResponse={searchResponse} classes={classes}/>
        )}
        
    </Box>
  );
};

export default AdditionalPartyDetails;
